export const EVENT_TITLE = 'EVENT_TITLE';
export const LOCATION = 'LOCATION';
export const LOCATION_ICON = 'LOCATION_ICON';
export const DESCRIPTION = 'DESCRIPTION';
export const DESCRIPTION_BUTTON = 'DESCRIPTION_BUTTON';
export const RESET_FILTERS_BUTTON = 'RESET_FILTERS_BUTTON';
export const FILTERS_SECTION = 'FILTERS_SECTION';
export const TAGS_SHOW_ALL_BUTTON = 'TAGS_SHOW_ALL_BUTTON';
export const LOCATION_DROPDOWN = 'LOCATION_DROPDOWN';
export const SCHEDULE_TITLE = 'SCHEDULE_TITLE';
export const SCHEDULE_ITEM = 'SCHEDULE_ITEM';
export const SCHEDULE_ITEM_DATETIME = 'SCHEDULE_ITEM_DATETIME';
export const SCHEDULE_ITEM_DURATION = 'SCHEDULE_ITEM_DURATION';
export const SCHEDULE_ITEM_NAME = 'SCHEDULE_ITEM_NAME';
export const MOBILE_SCHEDULE_ITEM = 'MOBILE_SCHEDULE_ITEM';
export const MOBILE_FILTER_MODAL = 'MOBILE_FILTER_MODAL';
export const MOBILE_FILTER_LOCATION_RADIO = 'MOBILE_FILTER_LOCATION_RADIO';
export const MOBILE_FILTER_TAG_CHECKBOX = 'MOBILE_FILTER_TAG_CHECKBOX';
export const MOBILE_FILTER_SUBMIT = 'MOBILE_FILTER_SUBMIT';
export const MOBILE_FILTER_RESET = 'MOBILE_FILTER_RESET';
export const MOBILE_FILTER_BUTTON = 'MOBILE_FILTER_BUTTON';
export const GET_TICKETS_BUTTON = 'GET_TICKETS_BUTTON';
export const CREATE_BOOKMARK = 'CREATE_BOOKMARK';
export const DELETE_BOOKMARK = 'DELETE_BOOKMARK';
export const MY_AGENDA_BUTTON = 'MY_AGENDA_BUTTON';
export const PERSONAL_AGENDA_DONE_BUTTON = 'PERSONAL_AGENDA_DONE_BUTTON';
export const PERSONAL_AGENDA_EMPTY_STATE = 'PERSONAL_AGENDA_EMPTY_STATE';
export const PERSONAL_AGENDA_MODAL_CONTENT = 'PERSONAL_AGENDA_MODAL_CONTENT';
export const TPA_MODAL_CONTENT = 'tpa-modal-content';
export const TAGS_LIST_TAG = 'tags-list-tag';
export const TAGS_LIST_TAG_INPUT = 'tags-list-tag-input';
export const CLOSE_BUTTON = 'close-btn';
//# sourceMappingURL=schedule.js.map